import { Flex, Typography } from '@banhala/ui-kit';
import { StyleSheet, View } from 'react-native';
import type { MumulLiveStatusDisplay } from '../constants/mumulLiveStatusDisplay';

type Props = {
  display: MumulLiveStatusDisplay;
  onPress?: () => void;
};

/**
 * 무물라이브 상태 표시 — 색상 dot + 안내 텍스트 (마켓명 아래 줄).
 * 프로필 이미지와 동일한 클릭 액션을 가진다.
 */
export const MumulLiveStatusText = ({ display, onPress }: Props) => (
  <Flex alignSelf={'flex-start'} onPress={onPress}>
    <View style={styles.row}>
      <View style={[styles.dot, { backgroundColor: display.dotColor }]} />
      <Typography type={'body3'} rawColor={display.textColor}>
        {display.text}
      </Typography>
    </View>
  </Flex>
);

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    paddingHorizontal: 2,
    paddingBottom: 3,
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 3,
  },
});
